var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.042,
    height: 86.271,
    viewBox: "0 0 68.042 86.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M15.073,88.648h42.6q6.336,0,9.527-3.23T70.4,75.81V39.472a29.4,29.4,0,0,0-.3-4.558,10.177,10.177,0,0,0-1.151-3.39,15.8,15.8,0,0,0-2.537-3.241L44.875,6.4a12.482,12.482,0,0,0-4.733-3.238,18.734,18.734,0,0,0-5.915-.788H15.073q-6.3,0-9.508,3.249T2.354,15.254V75.81q0,6.378,3.211,9.608T15.073,88.648Zm.48-7.185a5.976,5.976,0,0,1-4.48-1.541,6.111,6.111,0,0,1-1.5-4.435V15.577a6.078,6.078,0,0,1,1.515-4.417,6,6,0,0,1,4.5-1.56H33V32.137q0,4.044,2.006,6.05t6.012,2.006H63.21V75.488a5.37,5.37,0,0,1-6.053,5.976Zm26.24-47.792a1.98,1.98,0,0,1-2.3-2.3V10.75L62.06,33.671Z",
    transform: "translate(-2.354 -2.378)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadBig);
export default __webpack_public_path__ + "static/media/document-upload-big.a2835759e4dcc719bdf60b372bbcaac3.svg";
export { ForwardRef as ReactComponent };